import { ProviderPermissions } from '@provider-portal/common/services/types/account';

import { Facade } from '@bolteu/lattice';

/**
 * Permission entry for a menu/category item
 * @template T Is the list of possible permission keys
 * (can also be string for making it generic)
 */
export interface MenuEntryPermissions<T = keyof ProviderPermissions> {
  type: 'all' | 'oneOf';
  values: T[];
}

export interface ConfigMenuItem {
  id: string;
  titleIntlId: string;
  href: string;
  permission?: MenuEntryPermissions;
  hidden?: boolean;
}
export interface ConfigMenuCategory {
  id: string;
  titleIntlId: string;
  items: ConfigMenuItem[];
  permission?: MenuEntryPermissions;
  hidden?: boolean;
}

export interface ConfigMenu {
  menu: ConfigMenuCategory[];
}

export function isMenuLink(item: any): item is Facade.MenuLink {
  return item && item.link !== undefined;
}

export function isMenuItem(item: any): item is Facade.MenuItem {
  return item && item.children !== undefined;
}
